export type TFeedbackNudgeProps = {
  onAction: (action: ENudgeAction) => void;
  onClose: () => void;
};

export enum ENudgeAction {
  LIKE = 'LIKE',
  DISLIKE = 'DISLIKE',
  COMMENT = 'COMMENT',
}

export type TNudgeActionConfig = {
  icon: string;
  tooltipId: string;
  ariaLabel: string;
  testId: string;
};
